import React, { useEffect, useState } from 'react';
import HeroAuctions from '../../../components/hero/HeroAuctions';
import useDocumentTitle from '../../../components/useDocumentTitle';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { Dropdown } from 'react-bootstrap';
import Pagination from '../../../components/Pagination';
import { ToastContainer } from 'react-toastify';
import { convertEpochToDateTime, GetAuctionList } from '../../../hooks/AuctionHook';
import { listNFTs } from '../../../hooks/NFTHook';
import AuctionDynamicNFTCard from '../../../components/cards/auction/AuctionDynamicCard';
import NFTCardPlaceholder from '../../../components/cards/NFTCardPlaceholder';

const filter = ["Art", "Games", "Trading Cards", "Music", "Graphics", "Video", "Memes", "Collectibles", "others"]
const LiveAuctions = () => {
  useDocumentTitle('Live Auctions');
  const [activeTab, setActiveTab] = useState("open");
  const [selectedCategory, setSelectedCategory] = useState("All");
  console.log(
    "filrer", filter[0]
  );

  const [auctions, setAuctions] = useState([]);
  const walletAddress = localStorage.getItem("WalletAddress");
  const [isPagination, setIsPagination] = useState(true);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [limit, setLimit] = useState(8); // Items per page
  const [hasMore, setHasMore] = useState(true); // Flag for infinite scroll
  const userIds = localStorage.getItem("userId");

  useEffect(() => {
    GetAuctions()
  }, [activeTab]);

  const GetAuctions = async () => {
    setHasMore(true);
    const params = { page: currentPage + 1, limit, active: activeTab === "open" ? true : false, sortBy: "createdAt" }
    const { success, data, total, totalPages, page } = await GetAuctionList(params)
    if (success) {
      console.log("AuctionListActive", data, total, totalPages, page);
      // setAuctions(data)
      const collectionsWithMarketData = await Promise.all(
        data.map(async (collection) => {
          const marketData = await fetchMarketData(collection);
          console.log("marketData", marketData);
          const MarketNFTs = marketData.data;
          const AddIsLikeFlag = MarketNFTs.map(item => {
            const isLike = item.likes.some(like =>
              like.userId === userIds // Check if the user's ID exists in the likes array
            );

            return { ...item, isLike }; // Merge the `isLike` flag into the NFT object
          });
          const getEndTime = convertEpochToDateTime(collection.endTime)
          console.log("AddIsLikeFlag", AddIsLikeFlag, getEndTime);
          return {
            ...collection,
            endTime: getEndTime,
            ...AddIsLikeFlag[0]
          };
        })
      );
      console.log("collectionsWithMarketData", collectionsWithMarketData);
      setTimeout(() => {
        setAuctions(collectionsWithMarketData)
        setPageCount(totalPages)
        setHasMore(total > 0)
        setIsPagination(totalPages > 1)
      }, 2000);
    }
    else {
      setHasMore(false)
    }

  }
  
  const fetchMarketData = async (data) => {
    try {
      const params = {
        tokenId: data.tokenId,
        contractAddress: data.collectionAddress,
      };
      const response = await listNFTs(params);
      console.log("response", response, params);

      return response.success ? response : { success: false, data: [] };
    } catch (error) {
      console.error("Error fetching market data:", error);
      return { success: false, data: [] };
    }
  };

  const handlePageChange = (selectedItem) => {
    setCurrentPage(selectedItem.selected);
  };

  return (
    <div>
      <HeroAuctions />
      <div className="mt-100">
        <div className="container">

          <div className="section__head d-flex align-items-center justify-content-between">
            <div className="">
              <h2 className="section__title text-left">Hot bids 🔥</h2>
            </div>
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                {selectedCategory === "All" ? "Filter by Category" : selectedCategory}
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item onClick={() => setSelectedCategory("All")}>All</Dropdown.Item>
                {filter.map((data, index) => (
                  <Dropdown.Item key={index} onClick={() => setSelectedCategory(data)}>
                    {data}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

          </div>
          <Tabs className="space-x-10">
            <div className="d-flex justify-content-between">
              <TabList className="d-flex space-x-10 mb-30 nav-tabs">
                <Tab className="nav-item">
                  <button className="btn btn-white btn-sm" onClick={() => setActiveTab("open")}>Open</button>
                </Tab>
                <Tab>
                  <button className="btn btn-white btn-sm" onClick={() => setActiveTab("close")}>Closed</button>
                </Tab>
              </TabList>
            </div>
            <div className="tab-content">

              <div className="row">
                {auctions.length !== 0 ? auctions.map((val, i) => (
                  <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 card-hover-effect" key={i}>
                    <AuctionDynamicNFTCard
                      NFTLink={`/auction/details/${val.contractAddress}/${val.auctionId}`}
                      currentOwnerPic={val?.currentOwner?.userId?.profilePicture}
                      currentOwnerName={val?.currentOwner?.userId?.name}
                      currentOwnerLink={val?.currentOwner?.walletAddress !== walletAddress ? `/otherProfile/${val?.currentOwner?.walletAddress}` : "/profile"}
                      mediaUrl={val.imageUri} // Can be an image or video URL
                      assetType={val.AssetType} // Pass true for video or false for image
                      title={val.title}
                      price={val.price}
                      likes={val.totalLikes}
                      isLiked={val.isLike}
                      isListed={val.listed}
                      tokenId={val.tokenId}
                      endTime={val.endTime}
                      nftId={val._id}
                    />
                  </div>
                )) : (hasMore ?
                  // Display skeleton loader while fetching data
                  <>
                    {[...Array(limit)].map((_, index) => (
                      <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
                        {/* <Skeleton height={300} /> */}
                        <NFTCardPlaceholder />
                      </div>
                    ))}
                  </> :
                  <h3>
                    No NFT Available
                  </h3>
                )}
                {isPagination &&
                  <Pagination
                    pageCount={pageCount}
                    onPageChange={handlePageChange}
                    currentPage={currentPage}
                  />
                }
              </div>
            </div>
          </Tabs>
        </div>
      </div>
      <ToastContainer position='bottom-right' />
    </div>
  );
};

export default LiveAuctions;
